import type { Direction } from "@app/helpers/udm/get-display-price";
import type { AmplitudeEvent } from "@app/types/tracking/common";
import type {
  CloseItineraryDrawer,
  CloseOptionsDrawer,
  CloseResultsFiltersDrawer,
  CloseSummaryCardDrawer,
  OpenItineraryDrawer,
  OpenResultsFiltersDrawer,
  OpenSummaryCardDrawer,
  ViewTermsAndConditions
} from "@app/types/tracking/drawer";

import { DrawerTrackingAction } from "./constants/tracking-action";

export function openItineraryDrawer(
  itinerary_direction?: string
): AmplitudeEvent<OpenItineraryDrawer> {
  return {
    action: DrawerTrackingAction.OpenItineraryDrawer,
    details: { itinerary_direction }
  };
}

export function closeItineraryDrawer(): AmplitudeEvent<CloseItineraryDrawer> {
  return {
    action: DrawerTrackingAction.CloseItineraryDrawer,
    details: {}
  };
}

export function closeOptionsDrawer(): AmplitudeEvent<CloseOptionsDrawer> {
  return {
    action: DrawerTrackingAction.CloseOptionsDrawer,
    details: {}
  };
}

export function openResultsFiltersDrawer(): AmplitudeEvent<OpenResultsFiltersDrawer> {
  return {
    action: DrawerTrackingAction.OpenResultsFiltersDrawer,
    details: {}
  };
}

export function closeResultsFiltersDrawer(): AmplitudeEvent<CloseResultsFiltersDrawer> {
  return {
    action: DrawerTrackingAction.CloseResultsFiltersDrawer,
    details: {}
  };
}

export function openSummaryCardDrawer(
  direction: Direction
): AmplitudeEvent<OpenSummaryCardDrawer> {
  return {
    action: DrawerTrackingAction.OpenSummaryCardDrawer,
    details: {
      direction
    }
  };
}

export function closeSummaryCardDrawer(): AmplitudeEvent<CloseSummaryCardDrawer> {
  return {
    action: DrawerTrackingAction.CloseSummaryCardDrawer,
    details: {}
  };
}

export function ViewTermsAndConditions(
  direction: Direction
): AmplitudeEvent<ViewTermsAndConditions> {
  return {
    action: DrawerTrackingAction.ViewTermsAndConditions,
    details: {
      direction
    }
  };
}
